import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { DropdownButton, MenuItem } from 'react-bootstrap';

import { settings } from '../../lib/settings';

class SelectOrganization extends Component {
  render() {
    const {
      orgName,
      orgId,
      routeToOrg,
    } = this.props;

    const orgArr = settings.get('user.orgs', []);

    return (
      <DropdownButton
        bsStyle='primary'
        title={orgName}
        id='org-dropdown'
        style={{
          backgroundColor: 'transparent',
          border: 'none',
          padding: '8px 0px',
        }}
        ref={(c) => { this.orgMenu = c; }}
        className='title'
      >
        {_.map(orgArr, (org, key) => (
          <React.Fragment key={key}>
            {org.id !== orgId &&
              <MenuItem
                eventKey={key}
                onClick={() => {
                  routeToOrg(org.id);
                  // @xxx bug with DropdownButton
                  // Close dropdown button menu
                  document.dispatchEvent(new MouseEvent('click'));
                }}
              >
                {org.name}
              </MenuItem>
            }
          </React.Fragment>
        ))}
      </DropdownButton>
    );
  }
}

SelectOrganization.propTypes = {
  payload: PropTypes.shape({}),
  query: PropTypes.shape({}),
  orgId: PropTypes.string,
  orgName: PropTypes.string,
  routeToOrg: PropTypes.func.isRequired,
};

SelectOrganization.defaultProps = {
  payload: {},
  query: {},
  orgId: '',
  orgName: 'Unknown',
};

export default SelectOrganization;



// WEBPACK FOOTER //
// ./src/views/Components/SelectOrganization.js